/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { organizationMembersGet$Json } from '../fn/organization-members/organization-members-get-json';
import { OrganizationMembersGet$Json$Params } from '../fn/organization-members/organization-members-get-json';
import { organizationMembersGet$Plain } from '../fn/organization-members/organization-members-get-plain';
import { OrganizationMembersGet$Plain$Params } from '../fn/organization-members/organization-members-get-plain';
import { organizationMembersOrganizationUserIdDelete } from '../fn/organization-members/organization-members-organization-user-id-delete';
import { OrganizationMembersOrganizationUserIdDelete$Params } from '../fn/organization-members/organization-members-organization-user-id-delete';
import { organizationMembersOrganizationUserIdRolePut$Json } from '../fn/organization-members/organization-members-organization-user-id-role-put-json';
import { OrganizationMembersOrganizationUserIdRolePut$Json$Params } from '../fn/organization-members/organization-members-organization-user-id-role-put-json';
import { organizationMembersOrganizationUserIdRolePut$Plain } from '../fn/organization-members/organization-members-organization-user-id-role-put-plain';
import { OrganizationMembersOrganizationUserIdRolePut$Plain$Params } from '../fn/organization-members/organization-members-organization-user-id-role-put-plain';
import { organizationMembersPost$Json } from '../fn/organization-members/organization-members-post-json';
import { OrganizationMembersPost$Json$Params } from '../fn/organization-members/organization-members-post-json';
import { organizationMembersPost$Plain } from '../fn/organization-members/organization-members-post-plain';
import { OrganizationMembersPost$Plain$Params } from '../fn/organization-members/organization-members-post-plain';
import { OrganizationUserDto } from '../models/organization-user-dto';
import { OrganizationUserResponse } from '../models/organization-user-response';

@Injectable({ providedIn: 'root' })
export class OrganizationMembersApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationMembersGet()` */
  static readonly OrganizationMembersGetPath = '/organization/members';

  /**
   * List organization members.
   *
   * Lists all members with their roles in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationMembersGet$Plain$Response(params?: OrganizationMembersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationUserResponse>>> {
    const obs = organizationMembersGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List organization members.
   *
   * Lists all members with their roles in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationMembersGet$Plain(params?: OrganizationMembersGet$Plain$Params, context?: HttpContext): Observable<Array<OrganizationUserResponse>> {
    const resp = this.organizationMembersGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationUserResponse>>): Array<OrganizationUserResponse> => r.body)
    );
  }

  /**
   * List organization members.
   *
   * Lists all members with their roles in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationMembersGet$Json$Response(params?: OrganizationMembersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationUserResponse>>> {
    const obs = organizationMembersGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List organization members.
   *
   * Lists all members with their roles in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationMembersGet$Json(params?: OrganizationMembersGet$Json$Params, context?: HttpContext): Observable<Array<OrganizationUserResponse>> {
    const resp = this.organizationMembersGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationUserResponse>>): Array<OrganizationUserResponse> => r.body)
    );
  }

  /** Path part for operation `organizationMembersPost()` */
  static readonly OrganizationMembersPostPath = '/organization/members';

  /**
   * Add member.
   *
   * Adds an existing user to the current organization with a given role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersPost$Plain$Response(params?: OrganizationMembersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
    const obs = organizationMembersPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add member.
   *
   * Adds an existing user to the current organization with a given role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersPost$Plain(params?: OrganizationMembersPost$Plain$Params, context?: HttpContext): Observable<OrganizationUserDto> {
    const resp = this.organizationMembersPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationUserDto>): OrganizationUserDto => r.body)
    );
  }

  /**
   * Add member.
   *
   * Adds an existing user to the current organization with a given role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersPost$Json$Response(params?: OrganizationMembersPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
    const obs = organizationMembersPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add member.
   *
   * Adds an existing user to the current organization with a given role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersPost$Json(params?: OrganizationMembersPost$Json$Params, context?: HttpContext): Observable<OrganizationUserDto> {
    const resp = this.organizationMembersPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationUserDto>): OrganizationUserDto => r.body)
    );
  }

  /** Path part for operation `organizationMembersOrganizationUserIdRolePut()` */
  static readonly OrganizationMembersOrganizationUserIdRolePutPath = '/organization/members/{organizationUserId}/role';

  /**
   * Change member role.
   *
   * Changes the role of an existing organization member.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersOrganizationUserIdRolePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersOrganizationUserIdRolePut$Plain$Response(params: OrganizationMembersOrganizationUserIdRolePut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
    const obs = organizationMembersOrganizationUserIdRolePut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change member role.
   *
   * Changes the role of an existing organization member.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersOrganizationUserIdRolePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersOrganizationUserIdRolePut$Plain(params: OrganizationMembersOrganizationUserIdRolePut$Plain$Params, context?: HttpContext): Observable<OrganizationUserDto> {
    const resp = this.organizationMembersOrganizationUserIdRolePut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationUserDto>): OrganizationUserDto => r.body)
    );
  }

  /**
   * Change member role.
   *
   * Changes the role of an existing organization member.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersOrganizationUserIdRolePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersOrganizationUserIdRolePut$Json$Response(params: OrganizationMembersOrganizationUserIdRolePut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
    const obs = organizationMembersOrganizationUserIdRolePut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change member role.
   *
   * Changes the role of an existing organization member.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersOrganizationUserIdRolePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersOrganizationUserIdRolePut$Json(params: OrganizationMembersOrganizationUserIdRolePut$Json$Params, context?: HttpContext): Observable<OrganizationUserDto> {
    const resp = this.organizationMembersOrganizationUserIdRolePut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationUserDto>): OrganizationUserDto => r.body)
    );
  }

  /** Path part for operation `organizationMembersOrganizationUserIdDelete()` */
  static readonly OrganizationMembersOrganizationUserIdDeletePath = '/organization/members/{organizationUserId}';

  /**
   * Remove member.
   *
   * Removes a member and optionally records leave reason.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationMembersOrganizationUserIdDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersOrganizationUserIdDelete$Response(params: OrganizationMembersOrganizationUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = organizationMembersOrganizationUserIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove member.
   *
   * Removes a member and optionally records leave reason.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationMembersOrganizationUserIdDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationMembersOrganizationUserIdDelete(params: OrganizationMembersOrganizationUserIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.organizationMembersOrganizationUserIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
